import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
// slices
import userDashboardReducer from './slices/UserDashboard/userDashboard';
import tenantReducer from './slices/Tenant/Tenant';
import mainReducer from './slices/Main/main';
import questionnaireSummaryReducer from './slices/Questionnaire/QuestionnaireSummary';
import questionnaireProgressReducer from './slices/Questionnaire/QuestionnaireProgress';
import deletedFilesReducer from './slices/Questionnaire/DeletedDocuments';
import propertyReducer from './slices/Compliance/Property';
import notificationReducer from './slices/Compliance/Notifications';
import questionReducer from './slices/ProntoHousingAdministration/Question';
import contactsReducer from './slices/ProntoHousingAdministration/Contacts';
import questionMapping from './slices/ProntoHousingAdministration/QuestionMapping';
import MappingTable from 'src/redux/slices/ProntoHousingAdministration/MappingTableSlice';
import formReducer from './slices/ProntoHousingAdministration/Form';
import certificationReducer from './slices/Compliance/Certification';
import fileManagerReducer from './slices/Compliance/FileManager';
import fileManagerV3Reducer from './slices/Compliance/FileManagerV3Slice';
import fileManagerLocksReducer from './slices/Compliance/FileManagerLocksSlice';
import fileManagerAlertsReducer from './slices/Compliance/FileManagerAlertsSlice';
import vacancyNotificationAlertsReducer from './slices/Compliance/VacancyNotificationAlertsSlice';
import certificationAlertsReducer from './slices/Compliance/CertificationAlertsSlice';
import signaturesReducer from './slices/Compliance/SignaturesSlice';
import documentManagerReducerV2 from './slices/Compliance/DocumentManagerV2';
import formManager from './slices/Compliance/FormManager';
import conversationsReducer from './slices/Compliance/Conversations';
import unitReducer from './slices/Compliance/Unit';
import buildingReducer from './slices/Compliance/Building';
import householdReducer from './slices/Compliance/Household';
import householdSearchReducer from './slices/Compliance/HouseholdSearch';
import conversationsV2 from './slices/conversationsV2';
import propertySetupReducer from './slices/PropertySetup/PropertySetup';
import certificationWorkbenchReducer from 'src/redux/slices/CertificationWorkbench/CertificationWorkbench';
import selectionCriteriaReducer from './slices/BulkCommunications/SelectionCriteriaSlice';
import CWFormsSlice from './slices/CertificationWorkbench/CWFormsSlice';
import calcBuilderReducer from './slices/CalcBuilder/CalcBuilderSlice';
import featureFlagsReducer from './slices/FeatureFlags';
import rentersDashboardReducer from './slices/RentersDashboard/RentersDashboardSlice';
import newRenterInterfaceReducer from './slices/NewRenterInterface/NewRenterInterfaceSlice';
import newRenterUIReducer from './slices/NewRenterInterface/NewRentersInterfaceUIManagementSlice';
import newRenterInterfaceUserReducer from './slices/NewRenterInterface/NewRenterInterfaceUserSlice';
import dataVaultProfileSurveyReducer from './slices/DataVault/dataVaultProfileSurveySlice';
import dataVaultSectionsReducer from './slices/DataVault/dataVaultSectionsSlice';
import dataVaultSectionDetailReducer from './slices/DataVault/dataVaultSectionDetailSlice';
import dataVaultAiSummaryReducer from './slices/DataVault/dataVaultAiSummarySlice';
import dataVaultHistoryCertificationsReducer from './slices/DataVault/dataVaultHistoryCertificationsSlice';
import dataVaultHistoryCertificationDetailReducer from './slices/DataVault/dataVaultHistoryCertificationDetailSlice';
import dataVaultElevationReducer from './slices/DataVault/dataVaultElevationSlice';
import dataVaultManagedMembersReducer from './slices/DataVault/dataVaultManagedMembersSlice';
import dataVaultPersonalInfoReducer from './slices/DataVault/dataVaultPersonalInfoSlice';
import interviewReducer from './slices/Interview/interviewSlice';
import surveySectionsReducer from './slices/Survey/surveySectionsSlice';
import surveySectionDetailReducer from './slices/Survey/surveySectionDetailSlice';
import surveyMetaReducer from './slices/Survey/surveyMetaSlice';
import surveyFileQuestionsReducer from './slices/Survey/surveyFileQuestionsSlice';

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const rootReducer = combineReducers({
  userDashboard: userDashboardReducer,
  featureFlags: featureFlagsReducer,
  property: propertyReducer,
  question: questionReducer,
  form: formReducer,
  tenant: tenantReducer,
  questionnaireProgress: questionnaireProgressReducer,
  main: mainReducer,
  contact: contactsReducer,
  certification: certificationReducer,
  fileManager: fileManagerReducer,
  fileManagerV3: fileManagerV3Reducer,
  fileManagerLocks: fileManagerLocksReducer,
  fileManagerAlerts: fileManagerAlertsReducer,
  vacancyNotificationAlerts: vacancyNotificationAlertsReducer,
  certificationAlerts: certificationAlertsReducer,
  signatures: signaturesReducer,
  documentManagerV2: documentManagerReducerV2,
  formManager: formManager,
  conversations: conversationsReducer,
  conversationsV2: conversationsV2,
  questionMapping: questionMapping,
  mappingTable: MappingTable,
  unit: unitReducer,
  building: buildingReducer,
  household: householdReducer,
  householdSearch: householdSearchReducer,
  notification: notificationReducer,
  questionnaireSummary: questionnaireSummaryReducer,
  deletedDocuments: deletedFilesReducer,
  propertySetup: propertySetupReducer,
  certificationConfigurationWorkbench: certificationWorkbenchReducer,
  selectionCriteria: selectionCriteriaReducer,
  cwForms: CWFormsSlice,
  calcBuilder: calcBuilderReducer,
  rentersDashboard: rentersDashboardReducer,
  newRenterInterface: newRenterInterfaceReducer,
  newRenterUI: newRenterUIReducer,
  newRenterInterfaceUser: newRenterInterfaceUserReducer,
  dataVaultProfileSurvey: dataVaultProfileSurveyReducer,
  dataVaultSections: dataVaultSectionsReducer,
  dataVaultSectionDetail: dataVaultSectionDetailReducer,
  dataVaultAiSummary: dataVaultAiSummaryReducer,
  dataVaultHistoryCertifications: dataVaultHistoryCertificationsReducer,
  dataVaultHistoryCertificationDetail:
    dataVaultHistoryCertificationDetailReducer,
  dataVaultElevation: dataVaultElevationReducer,
  dataVaultManagedMembers: dataVaultManagedMembersReducer,
  dataVaultPersonalInfo: dataVaultPersonalInfoReducer,
  interview: interviewReducer,
  surveySections: surveySectionsReducer,
  surveySectionDetail: surveySectionDetailReducer,
  surveyMeta: surveyMetaReducer,
  surveyFileQuestions: surveyFileQuestionsReducer,
});

export { rootPersistConfig, rootReducer };
